import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, tap } from "rxjs";
import { AdminFilterParams, StudentApplicationResponse, UpdateStartDate } from "./Interfaces";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({
  providedIn: "root",
})
export class ApplicationService {
  getAllCountries(): Observable<any> {
    return this.http
      .get<any>("https://countriesnow.space/api/v0.1/countries")
      .pipe();
  }
  GetStateFromZipcode(zip: any): Observable<any> {
    return this.http.get<any>(`/zipcode/zip/${zip}`).pipe();
  }
  getPrograms(): Observable<any> {
    return this.http.get<any>("/program/getAll").pipe();
  }
  getStartDates(): Observable<any> {
    return this.http.get<any>("/program-dates/getAll").pipe();
  }
  getprogramInfo(id: number | string) {
    // const url = "/studentapplication/programinformation/1";
    return this.http
      .get<any>(`/studentapplication/programinformation/${id}`)
      .pipe();
  }
  getStudentApplicationForms(page: number, size: number): Observable<any> {
    return this.http
      .get<any>(
        `/studentapplication/getallstudentapplication?page=${page}&size=${size}`
      )
      .pipe();
  }

  getApplicationDetails(id: any): Observable<any> {
    return this.http.get<any>(`/studentapplication/get/${id}`).pipe();
  }

  getSheduleTypes(): Observable<any> {
    return this.http.get<any>("/schedule-type/getAll").pipe();
  }

  getProgramsByScheduleType(scheduleTypeId: number): Observable<any> {
    return this.http
      .get<any>(`/program/getProgramsByScheduleType/${scheduleTypeId}`)
      .pipe();
  }

  fetchProgramDates(programId: number, scheduleId: number): Observable<any> {
    if (programId && scheduleId) {
      return this.http
        .get<any>(`/program-dates/dates/${programId}/${scheduleId}`)
        .pipe();
    } else {
      return of([]); // Return an empty array if programId or scheduleId is not provided
    }
  }

  getRelationships(): Observable<any> {
    return this.http.get<any>("/relationship/getAll?page=0&size=50").pipe();
  }
  getEducationLevels(): Observable<any> {
    return this.http.get<any>("/education-level/getAll").pipe();
  }
  getRaces(): Observable<any> {
    return this.http.get<any>("/race/getAll").pipe();
  }
  updateApplicationDate(payload: UpdateStartDate) {
    return this.http.put<any>('/studentapplication/adminupdateselectedprogram', payload)

  }

  postProgramSelection(selection: any): Observable<any> {
    return this.http.post<any>(
      "/studentapplication/selectprogram",
      selection,
      httpOptions
    );
  }
  putProgramSelection(selection: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/updateselectprogram",
      selection,
      httpOptions
    );
  }

  putPersonalInfo(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/personalinfo",
      payload,
      httpOptions
    );
  }
  putEmergencyContact(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/emergencycontact",
      payload,
      httpOptions
    );
  }
  putEthnicity(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/ethnicity",
      payload,
      httpOptions
    );
  }
  putDisability(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/disabilityapp",
      payload,
      httpOptions
    );
  }
  putProgramOptions(payload: FormData): Observable<any> {
    return this.http.put<any>("/studentapplication/selectprogram", payload);
  }
  putStudentVerification(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/studentverification",
      payload,
      httpOptions
    );
  }
  putStudentSource(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/studentsource",
      payload,
      httpOptions
    );
  }
  putMilitaryRecord(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/militaryrecord",
      payload,
      httpOptions
    );
  }
  putEducationBackround(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/edubackground",
      payload,
      httpOptions
    );
  }
  putEmploymentAndExperience(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/employmentandexperience",
      payload,
      httpOptions
    );
  }
  putCitizenship(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/citizenship",
      payload,
      httpOptions
    );
  }
  putBackgroundInfo(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/backgroundinfo",
      payload,
      httpOptions
    );
  }
  putCertificateAgreement(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/certagreement",
      payload,
      httpOptions
    );
  }
  putDocumentUploads(payload: FormData): Observable<any> {
    return this.http.put<any>("/studentapplication/documentupload", payload);
  }
  getDocument(entityId: any, fileName: any) {
    return this.http
      .get(`/documents/details/${entityId}/${fileName}`, {
        responseType: "blob",
      })
      .pipe();
  }
  getOneDocument(url: any) {
    return this.http
      .get(`${url}`, {
        responseType: "blob",
      })
      .pipe();
  }
  getUrlDocuments(url: any) {
    return this.http
      .get(`${url}`, {
        responseType: "blob",
      })
      .pipe();
  }
  getAnApplicationsDocuments(id: any): Observable<any> {
    return this.http
      .get<any>(`/documents/getDocuments/Application/${id}`)
      .pipe();
  }
  putStatementOfUnderstanding(payload: any) {
    return this.http.put<any>(
      "/studentapplication/conditions",
      payload,
      httpOptions
    );
  }
  putApplicantSignature(payload: any): Observable<any> {
    return this.http.put<any>(
      "/studentapplication/applicantsignature",
      payload
    );
  }

  downloadApplication(R_appId: any): Observable<any> {
    return this.http
      .get(`/report/ApplicationForm?R_appId=${R_appId}`, {
        observe: "response",
        responseType: "blob",
      })
      .pipe();
  }
  getApplications(
    params: AdminFilterParams
  ): Observable<StudentApplicationResponse> {
    let httpParams = new HttpParams()
      .set("page", params.page.toString())
      .set("size", params.size.toString());

    if (params.programId !== undefined) {
      httpParams = httpParams.set("programId", params.programId.toString());
    }

    if (params.scheduleTypeId !== undefined) {
      httpParams = httpParams.set(
        "scheduleTypeId",
        params.scheduleTypeId.toString()
      );
    }

    if (params.programScheduleId !== undefined) {
      httpParams = httpParams.set(
        "programScheduleId",
        params.programScheduleId.toString()
      );
    }

    if (params.startDate) {
      httpParams = httpParams.set(
        "startDate",
        params.startDate === "Invalid date" ? "" : params.startDate
      );
    }

    if (params.endDate) {
      httpParams = httpParams.set(
        "endDate",
        params.endDate === "Invalid date" ? "" : params.endDate
      );
    }

    if (params.applicationStatus) {
      httpParams = httpParams.set(
        "applicationStatus",
        params.applicationStatus
      );
    }

    if (params.searchTerm) {
      httpParams = httpParams.set("searchTerm", params.searchTerm);
    }

    return this.http.get<StudentApplicationResponse>(
      `/studentapplication/getAll`,
      { params: httpParams }
    );
  }

  constructor(private http: HttpClient) { }
}
